import {createContext,useContext,type ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {useContentLinkIntent,type ContentLinkIntent} from '@/core/content-link-intent';
import {Button} from '@/ui';
import type {ChatMediaViewerProps} from '../public';
import {SheetFrame} from '../sheets/SheetFrame';

interface ViewerAction {intent:ContentLinkIntent;activate(mediaId?:string):void}
const Context=createContext<ViewerAction|undefined>(undefined);
export const useViewerAction=()=>useContext(Context);
export function MediaViewerAction({children,...props}:ChatMediaViewerProps&{children:ReactNode}){
 const identity=JSON.stringify([props.conversationId,props.messageId,props.seq,props.partIndex]);
 const gate=useContentLinkIntent(identity,true),{t}=useTranslation('chat');
 if(!gate.intent)return <SheetFrame title={t('media.title')} onClose={props.onClose} className="chat-media-viewer"><Button onClick={()=>gate.activate()}>{t('media.open')}</Button></SheetFrame>;
 return <Context.Provider value={{intent:gate.intent,activate:gate.activate}}>{children}</Context.Provider>;
}
